import { Utility, utility_controller } from '../utility/utility_controller'
import mobile_menu_controller from '../mobile/mobile_menu_controller'
import history_controller from '../history/history_controller_new'
import unescape from 'lodash/unescape'
import load_html5_videos_controller from '../html5video/load_html5_videos_controller'
import { attachHlsIfNeeded } from '../html5video/hls_loader'

var mobile_projectthumbnails_controller = {
	i: function () {
		if (Utility.isTouchDevice) {
			bind_pt_mouseover_behaviour()
			applyAlwaysMouseoverState()
			if (layData.fi_mo_touchdevice_behaviour == 'mo_always') {
				window.laytheme.on('newpageshown', function () {
					applyAlwaysMouseoverState()
				})
				window.laytheme.on('overlayshown', function () {
					applyAlwaysMouseoverState()
				})
			}
		}
	},
}

export default mobile_projectthumbnails_controller

var doAjaxNavigation = true
if (layData.is_customize || layData.misc_options_disable_ajax == 'on') {
	// when set to false it will just do hard reload navigation
	doAjaxNavigation = false
}

var bind_pt_mouseover_behaviour = function () {
	if (layData.fi_mo_touchdevice_behaviour == 'mo_on_tap') {
		// Show mouseover state on touch or tap, tap again to enter project
		var touching = false
		var touchTimeout

		jQuery(document).on('touchstart', '.thumb[data-type]', function (event) {
			clearTimeout(touchTimeout)

			if (!this.classList.contains('hover')) {
				touching = true
				touchTimeout = setTimeout(function () {
					touching = false
				}, 100)

				event.stopPropagation()
				event.preventDefault()
				jQuery('.thumb').removeClass('hover')
				this.classList.add('hover')
			}
		})
		// tap is a tocca event: https://gianlucaguarini.com/Tocca.js/
		jQuery(document).on('tap', '.thumb[data-type]', function (event) {
			var $thumb = jQuery(this)
			if (doAjaxNavigation) {
				if (touching == false && this.classList.contains('hover')) {
					if (shouldBypassAjaxNavigation($thumb, event)) {
						// Let the browser handle this anchor as a regular link.
						return
					}
					event.stopPropagation()
					event.preventDefault()
					navigateOnTap($thumb, event)
				}
			} else {
				if (touching == false && this.classList.contains('hover')) {
					// let link work!
				} else {
					event.stopPropagation()
					event.preventDefault()
				}
			}
		})
	} else if (layData.fi_mo_touchdevice_behaviour == 'mo_on_tap_alt') {
		// When touching thumbnail, show mouseover state
		jQuery(document).on('touchstart', '.thumb[data-type]', function (event) {
			if (!this.classList.contains('hover')) {
				jQuery('.thumb').removeClass('hover')
				this.classList.add('hover')
			}
		})
	}
}

var applyAlwaysMouseoverState = function () {
	if (layData.fi_mo_touchdevice_behaviour != 'mo_always') {
		return
	}
	jQuery('.thumb[data-type]').addClass('hover')

	// Layout markup is shared by the server/master cache across desktop and
	// touch devices. A cached desktop thumbnail using "Play on mouseover" has
	// no autoplay marker, so make the actual touch client authoritative.
	jQuery('.thumb[data-type]:not(.has-mouseover-img) video').each(function () {
		var video = this
		video.classList.add('autoplay')
		video.setAttribute('autoplay', '')

		// Desktop-only lazy-on-mouseover markup deliberately has no <source>.
		// It can also arrive from the shared cache, so restore its source here.
		if (!video.querySelector('source') && video.getAttribute('data-mp4')) {
			var source = document.createElement('source')
			var shouldLazyLoad = load_html5_videos_controller.shouldLazyLoadVideos()
			source.setAttribute(shouldLazyLoad ? 'data-src' : 'src', video.getAttribute('data-mp4'))
			source.setAttribute('type', video.getAttribute('data-type') || 'video/mp4')
			video.appendChild(source)
			video.addEventListener('playing', function () {
				video.classList.add('lay-thumb-video-lazy-mouseover--playing')
			}, { once: true })
			if (shouldLazyLoad) {
				video.classList.add('video-lazyload')
				load_html5_videos_controller.observeSpecificVideo(video)
			} else {
				attachHlsIfNeeded(video)
				try {
					video.load()
				} catch (e) {}
			}
		}

		if (!video._layAlwaysMouseoverCanPlayBound) {
			video._layAlwaysMouseoverCanPlayBound = true
			video.addEventListener('canplay', function () {
				var canPlayPromise = video.play()
				if (canPlayPromise && typeof canPlayPromise.catch === 'function') {
					canPlayPromise.catch(function () {})
				}
			}, { once: true })
		}

		// Do not force video-lazyload thumbnails into the queue here. The shared
		// IntersectionObserver loads them near the viewport and the autoplay
		// state above makes playback start once their source is available.
		// Non-lazy videos already have a source, while cached desktop
		// lazy-on-mouseover markup is hydrated explicitly above.
		var playPromise = video.play()
		if (playPromise && typeof playPromise.catch === 'function') {
			playPromise.catch(function () {})
		}
	})
}

// taken from history controller
var navigateOnTap = function ($this, event) {
	// dont ajax when in customizer because somehow it doesn't work anyway

	if (doAjaxNavigation) {
		var href = $this.attr('href')
		href = utility_controller.filterURL(href)

		// don't do anything when on the same page
		if (jQuery('body').attr('data-type') == $this.attr('data-type') && jQuery('body').attr('data-id') == $this.attr('data-id')) {
			event.preventDefault()
			mobile_menu_controller.hideMobileMenu()
		}
		// check if this is not a custom link and nor command neither ctrl are pressed
		else if ($this.attr('data-type') != 'custom' && !event.metaKey && !event.ctrlKey) {
			event.preventDefault()
			var title = passedDataHistory.title
			var attr_title = $this.attr('data-title')
			if (typeof attr_title != 'undefined' && attr_title != '') {
				title = passedDataHistory.titleprefix + unescape($this.attr('data-title'))
			}
			var catid = $this.attr('data-catid') // Store as string, not array

			history_controller.pushState(
				{
					type: $this.attr('data-type'),
					id: $this.attr('data-id'),
					catid: catid,
					title: title,
					slug: $this.attr('data-slug'),
				},
				title,
				href
			)
		}
	}
}

var shouldBypassAjaxNavigation = function ($this, event) {
	if ($this.attr('target') == '_blank' || $this.attr('data-type') == 'custom' || event.metaKey || event.ctrlKey) {
		return true
	}

	if ($this.attr('data-type') == 'project' && layData.disable_projectsoverlays_on_touchdevices == 'on' && Utility.isTouchDevice) {
		return true
	}

	var href = $this.attr('href')
	if (!href) {
		return false
	}

	// Let browser handle off-origin links natively.
	var isAbsoluteUrl = /^https?:\/\//i.test(href)
	if (isAbsoluteUrl) {
		try {
			return new URL(href).origin !== window.location.origin
		} catch (error) {
			return false
		}
	}

	return false
}
